import { createContext } from 'react';

export const TextHighlightSuppressContext = createContext(false);
